import { Collapse, Grid, useMediaQuery } from '@mui/material';
import React, { useEffect, useRef } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import CalendarComponent from '../../../Experiences/Calendar/CalendarComponent';
import EditReservationForm from '../../EditReservation/EditReservationForm';
import ReservationRequestContent from '../../ReservationRequest/ReservationRequestContent';
import { AvailabilityMode } from '../../../../enums/experience';
import { AddOn } from '../../../../types/experience';

const ReservationForm = ({
    individualAsset,
    submitRef,
    mainBooking,
    onReservationSuccess,
    existingReservation,
}: {
    individualAsset: any;
    submitRef?: React.MutableRefObject<(() => Promise<void>) | null>;
    mainBooking: any;
    onReservationSuccess?: (response: any) => void;
    existingReservation?: any;
}) => {
    const isMobile = useMediaQuery('(max-width: 770px)');
    const reservationContentRef = useRef<HTMLDivElement>(null);
    const calendarRef = useRef<HTMLDivElement>(null);

    const methods = useFormContext();

    const { control, setValue } = methods;

    const experienceId = useWatch({
        control,
        name: 'itineraryItemInfo.experienceId',
    });

    const reservationFormState = useWatch({
        control,
        name: 'itineraryItemInfo.reservationFormState',
    });

    useEffect(() => {
        if (reservationFormState && reservationContentRef.current) {
            setTimeout(() => {
                reservationContentRef.current?.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start',
                });
            }, 350);
        }
    }, [reservationFormState]);

    const onSubmitCalendar = (data: any) => {
        setValue('itineraryItemInfo.reservationFormState', data);
    };

    const state = !!existingReservation
        ? {
              dates: [
                  {
                      startDate: existingReservation.startDate,
                      endDate: existingReservation.endDate,
                  },
              ],
              reservationData: existingReservation,
              times: {
                  checkin: existingReservation.bookingInfo?.checkinTime,
                  checkinFrom: existingReservation.bookingInfo?.checkinTime,
                  checkout: existingReservation.bookingInfo?.checkoutTime,
                  checkoutBefore: existingReservation.bookingInfo?.checkoutTime,
              },
          }
        : reservationFormState;

    const isAddOn =
        individualAsset?.availabilityMode !== AvailabilityMode.Standalone &&
        individualAsset?.addOnOf.some(
            (addOn: AddOn) => addOn.id === mainBooking?.module?.id,
        );

    return (
        <Grid item xs={12} container>
            {experienceId && !existingReservation && individualAsset && (
                <Grid sx={{ width: '100%', mt: -1, mb: 5 }}>
                    <div ref={calendarRef}>
                        <CalendarComponent
                            experience={individualAsset}
                            isItineraryItemForm={true}
                            numberOfMonths={isMobile ? 1 : 2}
                            onSubmitInParent={onSubmitCalendar}
                            startMonth={new Date(mainBooking.startDate)}
                        />
                    </div>
                </Grid>
            )}

            <Collapse in={experienceId}>
                <div ref={reservationContentRef}>
                    {individualAsset && state && !existingReservation && (
                        <ReservationRequestContent
                            reservationDetails={individualAsset}
                            isItineraryItemForm={true}
                            state={state}
                            submitRef={submitRef}
                            mainBooking={mainBooking}
                            onReservationSuccess={onReservationSuccess}
                            existingReservation={existingReservation}
                            isAddOn={isAddOn}
                        />
                    )}
                </div>
            </Collapse>
            {existingReservation && (
                <EditReservationForm
                    reservation={existingReservation}
                    isItineraryItemForm={true}
                    submitRef={submitRef}
                    onReservationSuccess={onReservationSuccess}
                />
            )}
        </Grid>
    );
};

export default ReservationForm;
